import React from "react";
import { useFieldArray } from "react-hook-form";
import "../constants/constants.css";
import InputFieldFormArray from "../inputFieldFormArray/InputFieldFormArray";
import InfoFieldsPosition from "../infoFieldsPosition/InfoFieldsPosition";
import ExtraInformation from "../extraInformation/ExtraInformation";
import "./AdPositionDetails.css";
import SpecsheetButtonWhite from "../../button/specsheetButtonWhite/SpecsheetButtonWhite";

const PositionDetails = ({
  control,
  register,
  index,
  indexAdPosition,
  indexPosition,
  showSidebarHtmlFileDetails,
}) => {
  const { fields, remove, append } = useFieldArray({
    control,
    name: `creatives[${index}].adPositions[${indexAdPosition}].positionsList[${indexPosition}].details`,
  });

  return (
    <div className="form-wrapper">
      <ul>
        <ExtraInformation
          register={register}
          index={index}
          indexAdPosition={indexAdPosition}
        />
        {fields.map((item, indexPositionDetails) => {
          return (
            <li key={item.id}>
              <div className="input-container">
                <div className="inner-input-position-details-form-container">
                  <h4>Specifications HTML File</h4>

                  <div className="html-specifications-wrapper">
                    <InputFieldFormArray
                      label="Title"
                      placeholder="Rectangle / etc"
                      fieldRef={register(
                        `creatives[${index}].adPositions[${indexAdPosition}].positionsList[${indexPosition}].details[${indexPositionDetails}].title`,
                        {
                          required: false,
                        }
                      )}
                      name={`creatives[${index}].adPositions[${indexAdPosition}].positionsList[${indexPosition}].details[${indexPositionDetails}].title`}
                      key={item.id}
                    />
                  </div>

                  <InfoFieldsPosition
                    {...{
                      control,
                      register,
                      index,
                      indexAdPosition,
                      indexPosition,
                      indexPositionDetails,
                    }}
                  />
                  <div className="delete-button-wrapper">
                    <button
                      className="delete-button"
                      type="button"
                      onClick={() => {
                        remove(indexPositionDetails);
                      }}
                    >
                      Delete <br /> HTML specifications
                    </button>
                  </div>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
      <button
        type="button"
        className="append-button"
        onClick={() =>
          append({
            title: "",
            infoFields: [
              {
                subject: "",
                text: "",
                type: "text",
                url: "",
              },
            ],
          })
        }
      >
        Add <br /> Specifications HTML File
      </button>

      <section className="done-section">
        <SpecsheetButtonWhite
          type="button"
          handleClick={showSidebarHtmlFileDetails}
        >
          Done
        </SpecsheetButtonWhite>
      </section>
    </div>
  );
};

export default PositionDetails;
